import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Modal, Button } from "react-bootstrap";

const InvoicesRequestModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} size="sm" centered onHide={()=>onClose()}>
      <Container fluid>
        <Modal.Body
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <p style={{ paddingTop: "5%" }}>{t("invoice-request-success-message")}</p>
          <Button
            variant="secondary"
            onClick={()=> onClose()}
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
            }}
          >
            {t("close")}
          </Button>
        </Modal.Body>
      </Container>
    </Modal>
  );
};

export default InvoicesRequestModal;
